var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.75C15.5858 15.75 15.25 16.0858 15.25 16.5C15.25 16.9142 15.5858 17.25 16 17.25V15.75ZM20 17.25C20.4142 17.25 20.75 16.9142 20.75 16.5C20.75 16.0858 20.4142 15.75 20 15.75V17.25ZM11 15.75C10.5858 15.75 10.25 16.0858 10.25 16.5C10.25 16.9142 10.5858 17.25 11 17.25V15.75ZM13 17.25C13.4142 17.25 13.75 16.9142 13.75 16.5C13.75 16.0858 13.4142 15.75 13 15.75V17.25ZM2 5.25H22V3.75H2V5.25ZM22.25 5.5V18.5H23.75V5.5H22.25ZM22 18.75H2V20.25H22V18.75ZM1.75 18.5V5.5H0.25V18.5H1.75ZM2 18.75C1.86193 18.75 1.75 18.6381 1.75 18.5H0.25C0.25 19.4665 1.0335 20.25 2 20.25V18.75ZM22.25 18.5C22.25 18.6381 22.1381 18.75 22 18.75V20.25C22.9665 20.25 23.75 19.4665 23.75 18.5H22.25ZM22 5.25C22.1381 5.25 22.25 5.36193 22.25 5.5H23.75C23.75 4.5335 22.9665 3.75 22 3.75V5.25ZM2 3.75C1.0335 3.75 0.25 4.5335 0.25 5.5H1.75C1.75 5.36193 1.86193 5.25 2 5.25V3.75ZM1 11.25H23V9.75H1V11.25ZM1 8.25H23V6.75H1V8.25ZM16 17.25H20V15.75H16V17.25ZM11 17.25H13V15.75H11V17.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.236053e093ef34c60e5b4cee386c04f4.svg";
export { ForwardRef as ReactComponent };